export default "__VITE_ASSET__582dbb18__"